import React from 'react';

function PatternList({ patterns, loading, page, totalPages, onPageChange, onPatternClick }) {
  const getConfidenceClass = (confidence) => {
    if (confidence >= 0.8) return 'high';
    if (confidence >= 0.5) return 'medium';
    return 'low';
  };

  if (loading) {
    return <div className="pattern-list">Loading...</div>;
  }

  // Safe fallback for undefined patterns
  const safePatterns = patterns || [];

  return (
    <div className="pattern-list">
      <div style={{ padding: '20px', borderBottom: '1px solid #eee' }}>
        <h2>Prerequisite Patterns</h2>
        <p style={{ color: '#666', margin: 0 }}>
          Click on a pattern to review and edit the parsed result
        </p>
      </div>
      
      {safePatterns.map((pattern, index) => (
        <div 
          key={index} 
          className="pattern-item clickable"
          onClick={() => onPatternClick && onPatternClick(pattern.pattern)}
          style={{ 
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
        >
          <div className="pattern-header">
            <div style={{ flex: 1 }}>
              <div className="pattern-text">{pattern.pattern}</div>
              <div className="pattern-meta">
                <span>{pattern.course_count} courses</span>
                <span>Examples: {pattern.example_courses?.join(', ') || 'No examples'}</span>
              </div>
            </div>
            <div>
              <span className={`confidence ${getConfidenceClass(pattern.preview_confidence || 0)}`}>
                {((pattern.preview_confidence || 0) * 100).toFixed(0)}% confidence
              </span>
            </div>
          </div>
          
          <div className="pattern-types">
            {(pattern.pattern_types || []).map((type, i) => (
              <span key={i} className="pattern-type">{type}</span>
            ))}
          </div>
          
          <div className="json-preview">
            <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '12px' }}>
              {JSON.stringify(pattern.preview_parsed || {}, null, 2)}
            </pre>
          </div>
        </div>
      ))}
      
      {totalPages > 1 && (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <button 
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
            style={{ marginRight: '10px' }}
          >
            Previous
          </button>
          <span>Page {page} of {totalPages}</span>
          <button 
            onClick={() => onPageChange(page + 1)}
            disabled={page === totalPages}
            style={{ marginLeft: '10px' }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default PatternList;
